import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SEARCH_TYPE_CUENTA, SearchService } from '@services/search-service';
import { Observable } from 'rxjs/Observable';
import { MdDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { PATH_REMITO_GENERAR } from 'app/navigation/navigation.module';
import { RemitosService } from '@services/remitos-service';

@Component({
  selector: 'app-remitos-motivo-dialog',
  templateUrl: './remitos-motivo-dialog.component.html',
  styleUrls: [
    './remitos-motivo-dialog.component.scss',
    '../remitos-common-styles.scss',
  ],
})
export class RemitosMotivoDialog implements OnInit {
  public motivo = '';

  constructor(
    private searchService: SearchService,
    private router: Router,
    public dialogRef: MdDialogRef<RemitosMotivoDialog>,
    private remitoService: RemitosService
  ) {}

  ngOnInit() {}

  crearRemito() {
    if (this.motivo.length > 0) {
      this.closeDialog();
      this.remitoService.motivoGeneracion = this.motivo;
      this.router.navigate([PATH_REMITO_GENERAR]);
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/common/remitos-motivo-dialog/remitos-motivo-dialog.component.ts